import { APIRequestCases } from "../../service/api/APIRequestCenter";

export const pendingRequestFilters = { state: "SUBMITTED", page: 1, limit: 1 } as const;

export function canReadPendingRequests(user: {
  access_token?: string;
  permission?: { roles_code: string; read: number; roles_active?: number }[];
}) {
  return (
    Boolean(user.access_token) &&
    (user.permission || []).some(
      (p) =>
        p.roles_code === "helpdesk_requests" &&
        Number(p.read) === 1 &&
        Number(p.roles_active ?? 1) !== 0
    )
  );
}

export function pendingRequestQuery(franchise: string, identity: string) {
  return {
    // Keep the prefix used by approve/reject invalidation; isolate users' caches.
    queryKey: ["request-center", franchise, "pending-count", identity],
    queryFn: async () => {
      const result = await APIRequestCases(franchise, pendingRequestFilters);
      const total = Number(result.total);
      if (!Number.isSafeInteger(total) || total < 0) throw new Error("Invalid pending count");
      return total;
    },
    retry: 1,
    staleTime: 15000,
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  };
}

export function combinePendingCounts(
  results: { isSuccess: boolean; isError: boolean; data?: number }[]
) {
  if (results.some((r) => r.isError)) return { count: undefined, isError: true };
  if (results.some((r) => !r.isSuccess)) return { count: undefined, isError: false };
  return { count: results.reduce((sum, r) => sum + (r.data ?? 0), 0), isError: false };
}
